import { Component, Input, Inject, OnInit } from '@angular/core';
import { IDataService } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-ui-field-special-payout-model',
  templateUrl: './payout-model.component.html',
})
export class PayoutModelComponent implements OnInit {
  @Input() data: string;
  public payoutModel: string;

  constructor(@Inject('IDataService') public dataService: IDataService) {}

  ngOnInit() {
    const globalData = this.dataService.getData();
    this.payoutModel = globalData.payout_type[this.data];
  }
}
